/**
 * @generated SignedSource<<aec7c7d15a68e9ccfb10cf6d3c93e5e1>>
 * @relayHash f80615342bea07d18fe9b588ee9c8938
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraUpdateVersionWarningConfigInput = {
  jiraProjectId: string;
  updatedVersionWarningConfig: JiraVersionUpdatedWarningConfigInput;
};
export type JiraVersionUpdatedWarningConfigInput = {
  isFailingBuildEnabled?: boolean | null | undefined;
  isOpenPullRequestEnabled?: boolean | null | undefined;
  isOpenReviewEnabled?: boolean | null | undefined;
  isUnreviewedCodeEnabled?: boolean | null | undefined;
};
export type ui_ManageWarningsModalVersionWarningConfigMutation$variables = {
  input: JiraUpdateVersionWarningConfigInput;
  versionId: string;
};
export type ui_ManageWarningsModalVersionWarningConfigMutation$data = {
  readonly jira: {
    readonly updateVersionWarningConfig: {
      readonly success: boolean;
      readonly version: {
        readonly " $fragmentSpreads": FragmentRefs<"issueProgressDetails_versionProgress">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ui_ManageWarningsModalVersionWarningConfigMutation = {
  response: ui_ManageWarningsModalVersionWarningConfigMutation$data;
  variables: ui_ManageWarningsModalVersionWarningConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionId"
  }
],
v4 = [
  {
    "kind": "ScalarField",
    "name": "totalCount"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionWarningConfigPayload",
            "kind": "LinkedField",
            "name": "updateVersionWarningConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "issueProgressDetails_versionProgress"
                      }
                    ],
                    "type": "JiraVersion"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionWarningConfigPayload",
            "kind": "LinkedField",
            "name": "updateVersionWarningConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraVersionWarningConfig",
                        "kind": "LinkedField",
                        "name": "warningConfig",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "failingBuild"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "openPullRequest"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "openReview"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "unreviewedCode"
                          }
                        ]
                      },
                      {
                        "alias": "doneIssuesRedesignTemp",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                              "statusCategories": [
                                "DONE"
                              ]
                            }
                          }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                      },
                      {
                        "alias": "inProgressIssuesRedesignTemp",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                              "statusCategories": [
                                "IN_PROGRESS"
                              ]
                            }
                          }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                      },
                      {
                        "alias": "todoIssuesRedesignTemp",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                              "statusCategories": [
                                "TODO"
                              ]
                            }
                          }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "warningsCount"
                      }
                    ],
                    "type": "JiraVersion"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce",
    "metadata": {},
    "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c4e2323c95f8ee01a7aae0a690ba4f89";

export default node;
